/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_NewInputs */

const cs_integrations_new = /** @type {(inputs: Integrations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová integrace`)
};

const en_integrations_new = /** @type {(inputs: Integrations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New integration`)
};

/**
* | output |
* | --- |
* | "New integration" |
*
* @param {Integrations_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_new = /** @type {((inputs?: Integrations_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_new(inputs)
	return cs_integrations_new(inputs)
});